import { Typography } from "@mui/material";
import React from "react";
import { legend__text } from "../style";

export default function FullDentureAcrylic() {
  return <Typography sx={legend__text}>FLD-ACR</Typography>;
}
